/**
 * Accordion
 * A component should render a little piece of UI.
 * It should not call any api, but should hold UI logic.
 * @class Accordion
 * @param {object} props - Props
 */

import React, { useCallback, useState } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import CirclePlus from "../icons/circle-plus-light.svg";
import CircleMinus from "../icons/circle-minus-light.svg";

const Accordion = ({ items = [] }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const updateImage = useCallback((event) => setActiveIndex(parseInt(event.target.name)), []);

  return (
    <div className="accordion">
      <div className="accordion__items">
        {items.length > 1 &&
          items.map((item, idx) => (
            <div
              key={idx}
              className={`accordion__item ${idx === activeIndex ? "accordion--active" : ""}`}
            >
              <div className="accordion__content">
                <div className="accordion__header">
                  <button type="button" name={idx} onClick={updateImage}>
                    {item.accordionTitle}
                    <CircleMinus className="minus" />
                    <CirclePlus className="plus" />
                  </button>
                </div>
                <div className="accordion__body">
                  {item.accordionText}
                  <div className="accordion__image accordion__image--mobile">
                    <GatsbyImage
                      image={getImage(
                        item.accordionImageMobile?.node || item?.accordionImageDesktop?.node
                      )}
                      alt={item.accordionImageMobile?.value?.description || ""}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
      <div className="accordion__image">
        {items.length > 1 &&
          items.map((item, idx) => (
            <div className={`${activeIndex === idx ? "active" : ""}`} key={idx}>
              <GatsbyImage
                image={getImage(item.accordionImageDesktop?.node)}
                alt={item.accordionImageDesktop?.value?.description || ""}
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default Accordion;
